import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import masterTcService from "services/Setup/Master/masterTcService";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  masterTcList: {},

  ROW_GUTTER: 16,
  SIDE_NAV_WIDTH: 250,
  SIDE_NAV_COLLAPSED_WIDTH: 80,
  SIDE_NAV_LIGHT: "SIDE_NAV_LIGHT",
  SIDE_NAV_DARK: "SIDE_NAV_DARK",
  NAV_TYPE_SIDE: "SIDE",
  NAV_TYPE_TOP: "TOP",
  DIR_LTR: "ltr",
  DIR_RTL: "rtl",
};

export const getMasterTcList = createAsyncThunk(
  "themeConstantSlice/getMasterTcList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await masterTcService.getMaterTcList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const themeConstantSlice = createSlice({
  name: "themeConstantSlice",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    setNavSeedebar: (state, action) => {
      console.log("🚀 ~ actionsetNavSeedebar:", action.payload);
      state.SIDE_NAV_WIDTH = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      //list
      .addCase(getMasterTcList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterTcList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterTcList = action.payload;
      })
      .addCase(getMasterTcList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  setNavSeedebar,
} = themeConstantSlice.actions;

export default themeConstantSlice.reducer;
